
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LowercaseTranslocoService {
    constructor(private translocoService: TranslocoService) { }

    translate(key: string, params?: any): string {
        const lowerCaseKey = key.toLowerCase();
        return this.translocoService.translate(lowerCaseKey, params);
    }
}
